import { useEffect, useState } from "react";

import GiftCardMediaProvider from "~/contexts/giftcard-media";
import CrossCountry from "~/types/cross-country";
import CommonUtils from "~/utils/common-utils";
import Constants from "~/utils/constants";
import productUtils from "~/utils/product-utils";

import Container from "../common/container";
import Grid from "../common/grid";
import ProductBeautyServices from "./product-beauty-services";
import { Breadcrumb } from "./product-breadcrumbs";
import ProductGallery from "./product-gallery";
import ProductInfo from "./product-info";
import ProductIntro from "./product-intro";
import ProductMoreInfo from "./product-more-info";
import ProductServicesIcons from "./product-services-icons";
import styles from "./product-showcase.module.scss";

type Props = {
  root: CrossCountry.DetailedProduct;
  shades: CrossCountry.Product[];
  selectedShade: CrossCountry.DetailedProduct;
  breadcrumbs: Breadcrumb[];
  isLoadingAvailability?: boolean;
  parent_backend_id: string;
  disableTris?: boolean;
};

export default function ProductShowcase(props: Props) {
  const [galleryIdx, setGalleryIdx] = useState(0);
  const [enabledGallery, setEnabledGallery] = useState(true);

  useEffect(() => {
    const hex = props.selectedShade?.hex_color;
    if (hex && CommonUtils.isColor(hex)) {
      const hexWithAlpha = hex + "26"; // 15% alpha
      document.body.style.setProperty("--fromRGBA", hexWithAlpha);
    }
  }, [props.selectedShade]);

  const isVirtualGiftCard = productUtils.isVirtualProduct(props.root) && productUtils.isGiftCard(props.root);

  return (
    <Container>
      <Grid className={styles.pdpGrid} id="pr-categorysnippet">
        <GiftCardMediaProvider config={isVirtualGiftCard ? props.root.giftCardConfig?.fields : undefined}>
          <div className={styles.pdpContainer}>
            <section className={styles.section1}>
              <ProductIntro
                root={props.root}
                selectedShade={props.selectedShade}
                galleryIdx={galleryIdx}
                onSelect={(i) => setGalleryIdx(i)}
                breadcrumbs={props.breadcrumbs}
                enabledGallery={enabledGallery}
                setEnabledGallery={setEnabledGallery}
                parent_backend_id={props.parent_backend_id}
              />
              <section id={Constants.PDP_GALLERY_SECTION} className={styles.section2}>
                <ProductGallery
                  rootId={props.root.product_id}
                  selectedShade={props.selectedShade}
                  galleryIdx={galleryIdx}
                  onSelect={(i) => setGalleryIdx(i)}
                  enabledGallery={enabledGallery}
                  setEnabledGallery={setEnabledGallery}
                />
              </section>
            </section>
            <section className={styles.section3}>
              <ProductInfo
                root={props.root}
                selectedShade={props.selectedShade}
                shades={props.shades}
                isLoadingAvailability={props.isLoadingAvailability}
                parent_backend_id={props.parent_backend_id}
              />
            </section>
          </div>
          <div className={styles.productServicesIconsDesktop}>
            {<ProductServicesIcons selectedShade={props.selectedShade} />}
          </div>
        </GiftCardMediaProvider>
        <div className={styles.productInfoMobile}>{<ProductMoreInfo selectedShade={props.selectedShade} />}</div>
        {!props.disableTris && <ProductBeautyServices root={props.root} selectedShade={props.selectedShade} />}
      </Grid>
    </Container>
  );
}
